// TODO: rename to context.ts
import { createLazyContext } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/context/custom/context-key-lazy.js';
export const relatedLinksContext = createLazyContext('related-links');
//# sourceMappingURL=interfaces.js.map